class Navigation {
	stateClasses = {
		linkActive: 'nav__item--active',
	};

	constructor($el) {
		this.$el = $el;
		this.$items = this.$el.find('[data-nav="item"]');
	}

	// methods to set active link with a given id
	setActiveLink = id => {
		this.$items.removeClass(this.stateClasses.linkActive);
		const $activeItem = this.$items.filter(`[data-id="${id}"]`);
		$activeItem.addClass(this.stateClasses.linkActive);
	};
}

export { Navigation };
